import type { TefComs4csMicroFrontend } from '@mfe-4cs/components/tef-coms4cs';
import type { ConsentStore } from '@mfe-4cs/state/ConsentStore';
import { stripHtml } from '@mfe-4cs/util/helpers';
import { html, nothing, TemplateResult } from 'lit';

export function consentTemplateOverview(this: TefComs4csMicroFrontend, consent: ConsentStore): TemplateResult {
  const { featureTitlesAsString } = consent;
  return html`
    <one-cluster>
      <one-text as="div">${stripHtml(consent.shortScope!)}</one-text>
      ${featureTitlesAsString ? html`
        <one-text as="div" strong>${featureTitlesAsString}</one-text>
      ` : nothing}
    </one-cluster>
  `;
}
